import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { GlobalService } from 'src/app/api/global.service';
import { BookingsExtendsComponent } from 'src/app/booking/bookings/bookings-extends/bookings-extends.component';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';

@Component({
  selector: 'app-schedule-open-list',
  templateUrl: './schedule-open-list.component.html',
  styleUrls: ['./schedule-open-list.component.css']
})
export class ScheduleOpenListComponent implements OnInit {
  @ViewChild(SearchComponent) searchComponent: any;
  @ViewChild(BookingsExtendsComponent) BookingsExtendsComponent: any;

  branchofficeSlug = '';
  date_range: any = null;
  tour: any = null;
  items: any = [];

  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    private bookingService: BookingsService,
    private globalService: GlobalService,
    private navigationTrackerService: NavigationTrackerService,
    private routeActivated: ActivatedRoute,
    private router: Router
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.bookingService.toursOpen(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  detailBookingExtends(booking: any) {
    this.BookingsExtendsComponent.init(booking.booking_id);
  }

  afterBookingDetail(data: any) {}

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/salidas/cronograma/lista'
    ]);
  }
}
